// extracted by css-extract-rspack-plugin
export default {"drawer":"Layout_drawer__IPFUI"};